'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoSocialBufferOutline = function IoSocialBufferOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm5.5 12.8c-0.7-0.3-0.7-0.8 0-1.2l13.3-6.4c0.3-0.1 0.7-0.2 1.2-0.2s0.9 0.1 1.3 0.2l13.2 6.4c0.7 0.4 0.7 0.9 0 1.2l-13.2 6.4c-0.4 0.2-0.8 0.3-1.3 0.3s-0.9-0.1-1.2-0.3z m13.8-6.4l-12.2 5.9 12.2 5.8c0.2 0.1 0.4 0.1 0.7 0.1s0.5 0 0.7-0.1l12.2-5.8-12.2-5.9c-0.2-0.1-0.4-0.1-0.7-0.1s-0.5 0-0.7 0.1z m15.2 13c0.7 0.3 0.7 0.9 0 1.2l-13.2 6.4c-0.4 0.1-0.8 0.3-1.3 0.3s-0.9-0.2-1.2-0.3l-13.3-6.4c-0.7-0.3-0.7-0.9 0-1.2 0 0 2.2-1 2.6-1.3 0.4-0.2 0.6-0.2 1 0s9.7 4.7 9.7 4.7c0.3 0.2 0.7 0.2 1.2 0.2s0.9 0 1.3-0.2c0 0 9.4-4.6 9.7-4.8s0.4-0.1 0.7 0 2.8 1.4 2.8 1.4z m-13.8 6.5l12.2-5.9-1.5-0.7-9.6 4.6c-0.5 0.2-1.2 0.4-1.8 0.4s-1.3-0.2-1.8-0.4l-9.6-4.6-1.5 0.7 12.2 5.9c0.2 0 0.4 0.1 0.7 0.1s0.6-0.1 0.7-0.1z m13.8 1.3c0.7 0.3 0.7 0.8 0 1.2l-13.2 6.4c-0.4 0.1-0.8 0.2-1.3 0.2s-0.9-0.1-1.2-0.2l-13.3-6.4c-0.7-0.4-0.7-0.9 0-1.2 0 0 2.2-1.1 2.6-1.3 0.4-0.3 0.6-0.2 1 0s9.7 4.6 9.7 4.6c0.3 0.2 0.7 0.3 1.2 0.3s0.9-0.1 1.3-0.3c0 0 9.4-4.5 9.7-4.6s0.4-0.2 0.7 0 2.8 1.3 2.8 1.3z m-13.8 6.4l12.2-5.9-1.5-0.7-9.6 4.7c-0.5 0.3-1.2 0.3-1.8 0.3s-1.3 0-1.8-0.3l-9.6-4.7-1.5 0.7 12.2 5.9c0.2 0.1 0.4 0.1 0.7 0.1s0.6 0 0.7-0.1z' })
        )
    );
};

exports.default = IoSocialBufferOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/social-buffer-outline.js
// module id = 2450
// module chunks = 0